import { IconButton, Tooltip } from '@ads/components-react';
import type { ComponentType } from 'react';

export interface ElementToolbarItemProps {
  readonly icon: ComponentType<React.SVGProps<SVGSVGElement>>;
  readonly label: string;
  readonly onClick: () => void;
  readonly disabled?: boolean;
}

export function ElementToolbarItem({
  icon,
  label,
  onClick,
  disabled = false,
}: ElementToolbarItemProps) {
  return (
    <Tooltip title={label} side="bottom">
      <IconButton
        icon={icon}
        ariaLabel={label}
        hierarchy="tertiary"
        size="sm"
        onClick={onClick}
        disabled={disabled}
      />
    </Tooltip>
  );
}
